import { useState } from 'react';

import { toastService } from '@thefarmersfront/kitchen';

import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT, TOAST_MESSAGE } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypeGetVendorReleaseRecentInfoResponse } from '~/types/stock.types';

/**
 * [재고관리] 반출 요청 > 최근 반출 도착지 정보 조회 api 요청 훅
 */
const useGetVendorReleaseRecentInfo = () => {
  const { runAsync } = useAsyncHandler();

  const [responseData, setResponseData] = useState<TypeGetVendorReleaseRecentInfoResponse['data'] | null>(null);

  const getVendorReleaseRecentInfo = useAPI<unknown, TypeGetVendorReleaseRecentInfoResponse>({
    endpoint: API_ENDPOINT.STOCK.GET_VENDOR_RELEASE_RECENT_INFO,
    method: 'get',
  });

  const requestVendorReleaseRecentInfo = async ({
    onSuccess,
    onError,
  }: {
    onSuccess?: (data: TypeGetVendorReleaseRecentInfoResponse['data']) => void;
    onError?: (error: TypeErrorResponseData['error']) => void;
  } = {}) => {
    runAsync(() => getVendorReleaseRecentInfo({}), {
      onSuccess: ({ data }) => {
        setResponseData(data);
        onSuccess?.(data);
      },
      onError: (error: TypeErrorResponseData['error']) => {
        toastService.addToast({
          type: 'error',
          message: error.message ?? TOAST_MESSAGE.DEFAULT_ERROR,
        });
        onError?.(error);
      },
    });
  };

  return { requestVendorReleaseRecentInfo, responseData };
};

export default useGetVendorReleaseRecentInfo;
